import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Col } from '@cancercentrum/rcc-bootstrap';
import FilterInput from './FilterInput';
export const RowFilter = /*#__PURE__*/ memo(function RowFilter(props) {
    const { focusFilter, filter, onChange, clearSort, hideResetFilterButton } = props;
    return /*#__PURE__*/ _jsx(Col, {
        md: 4,
        children: /*#__PURE__*/ _jsx(FilterInput, {
            isActive: !!filter,
            initialValue: filter,
            onChange: onChange,
            focus: focusFilter,
            clearSort: clearSort,
            hideResetFilterButton: hideResetFilterButton
        })
    });
});
